'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _ArrowButton = require('./ArrowButton.component');

var _ArrowButton2 = _interopRequireDefault(_ArrowButton);

require('../styles/RegularArrowButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegularArrowButton = function (_BcReactComponent) {
  _inherits(RegularArrowButton, _BcReactComponent);

  function RegularArrowButton() {
    _classCallCheck(this, RegularArrowButton);

    return _possibleConstructorReturn(this, (RegularArrowButton.__proto__ || Object.getPrototypeOf(RegularArrowButton)).apply(this, arguments));
  }

  _createClass(RegularArrowButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentPage = _props.currentPage,
          direction = _props.direction,
          disabled = _props.disabled,
          handleClick = _props.handleClick,
          pageSize = _props.pageSize,
          numberOfItems = _props.numberOfItems,
          props = _objectWithoutProperties(_props, ['currentPage', 'direction', 'disabled', 'handleClick', 'pageSize', 'numberOfItems']);

      return _react2.default.createElement(_ArrowButton2.default, _extends({}, props, {
        className: 'cp-regular-arrow-button',
        disabled: disabled,
        handleClick: handleClick,
        currentPage: currentPage,
        pageSize: pageSize,
        numberOfItems: numberOfItems,
        direction: direction }));
    }
  }]);

  return RegularArrowButton;
}(_baseBcReactComponent2.default);

exports.default = RegularArrowButton;


RegularArrowButton.propTypes = {
  currentPage: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  numberOfItems: _react.PropTypes.number,
  direction: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  handleClick: _react.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/components/RegularArrowButton.component.js
// module id = 1402
// module chunks = 1